import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import swal from "sweetalert";
import store from "../store";
import { jwtDecode } from "jwt-decode";
import moment from "moment-timezone";

export const showSuccess = (message) => {
  swal("Success", message || "", "success");
};
export const showError = (message, status, navigate = true) => {
  if (status === 401) {
    if (navigate) {
      swal("Session Expired", "", "error");
      removeCookie("token");
      window.location.href = "/login";
    } else {
      swal("Oops! Something went wrong", message || "", "error");
    }
  } else {
    swal("Oops! Something went wrong", message || "", "error");
  }
};

export const showInfo = (message) => {
  swal("Info", message || "", "success");
};

export const setCookie = (value, key) => {
  const isHttps = window.location.protocol === "https:";
  Cookies.set(key, value, {
    expires: 7,
    secure: isHttps,
    sameSite: isHttps ? "strict" : "lax",
  });
};

export const getCookie = (key) => Cookies.get(key);

export const removeCookie = (key) => Cookies.remove(key);

export const formatDate = (date) => {
  let months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];

  if (
    `${date}`.split(":")?.length === 3 &&
    `${date}`.split("-")?.length === 3
  ) {
    // Use UTC to parse date-only fields so timezone offset does not shift the
    // displayed calendar day (e.g. "2026-04-05T21:00:00Z" must show Apr 5, not Apr 6).
    const parsedDate = moment.utc(date);
    const day = parsedDate.get("date");
    const month = parsedDate.get("month");
    const year = parsedDate.get("year");

    return `${months[month]}-${day}-${year}`;
  } else {
    return date;
  }
};
export const formatDateWithMedTimezone = (date, businessTimezone) => {
  let months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];

  if (
    `${date}`.split(":")?.length === 3 &&
    `${date}`.split("-")?.length === 3
  ) {
    // const parsedDate = new Date(date);
    // const parsedDate = moment(date).tz(moment.tz.guess());
    const parsedDate = moment(date).tz(
      businessTimezone ? businessTimezone : moment.tz.guess(),
    );

    const day = parsedDate.get("date");
    const month = parsedDate.get("month");
    const year = parsedDate.get("year");

    return `${months[month]}-${day}-${year}`;
  } else {
    return date;
  }
};

export const formatTime = (date) => {
  if (
    `${date}`.split(":")?.length === 3 &&
    `${date}`.split("-")?.length === 3
  ) {
    return moment(date)?.format("hh:mm a");
  } else {
    return date;
  }
};

export const dateFormat2 = (inputDate, includeYear = false) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  const dateObject = new Date(inputDate);
  const day = dateObject.getDate();
  const monthIndex = dateObject.getMonth();
  const year = dateObject.getFullYear();

  const formattedDate = `${months[monthIndex]} ${day
    .toString()
    .padStart(2, "0")}${includeYear ? `, ${year}` : ""}`;

  return formattedDate;
};

export const isSubscriptionExpired = () => {
  return store?.getState()?.profile?.profile?.subscriptionExpired;
};

export const isSignatureActivated = () => {
  return store?.getState()?.profile?.profile?.user?.signatureActive;
};

export const isBillingEnabled = () => {
  return Boolean(store?.getState()?.featureFlags?.billing);
};

export function formatFileSize(bytes) {
  const units = ["Bytes", "KB", "MB", "GB"];
  let index = 0;
  while (bytes >= 1024 && index < units.length - 1) {
    bytes = bytes / 1024;
    index++;
  }
  return `${bytes.toFixed(2)} ${units[index]}`;
}

export const states = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const defaultImage = require("./../images/personal2.png");

export const getOptions = (
  optionType,
  custom,
  fieldName,
  withDeleted = false,
) => {
  // if(optionType === "Other") console.log("custom of other :", fieldName ,custom)
  let othersArray = [];
  if (custom && Array.isArray(custom)) {
    var classField = custom?.find(
      // (item) => item?.field === fieldName || item?.options === "Other"
      (item) => item?.field === fieldName,
    );
    if (classField) {
      othersArray = classField?.others
        ? classField?.others?.split(",")?.map((item) => item?.trim())
        : [];
    }
  }

  let multipleChoice = [];
  if (custom && Array.isArray(custom)) {
    let classField = custom?.find(
      (item) =>
        item?.options === "multipleOptions" && item?.field === fieldName,
    );
    multipleChoice = classField?.multipleChoice;
  }

  let singleChoice = [];
  if (custom && Array.isArray(custom)) {
    let classField = custom?.find(
      (item) => item?.options === "singleOptions" && item?.field === fieldName,
    );
    singleChoice = classField?.singleChoice;
  }

  let dropdownChoice = [];
  if (custom && Array.isArray(custom)) {
    let classField = custom?.find(
      (item) =>
        item?.options === "dropdownOptions" && item?.field === fieldName,
    );
    dropdownChoice = classField?.dropdownChoice;
  }

  let { allFacilities, allDeletedFacilities, allFacilityTypes } =
    store?.getState()?.facility;
  let { allPatients } = store?.getState()?.patient;
  // let { allAssignPatients } = store?.getState()?.patient;
  let { staff, allStaff } = store?.getState()?.staff;

  // if (otherOptions) othersArray = otherOptions;

  const returnFacilitiesArray = () => {
    if (withDeleted === true) {
      if (allDeletedFacilities?.facilities) {
        return allDeletedFacilities?.facilities?.map((value) => ({
          value: value?.id,
          label: value?.name,
        }));
      } else {
        return [];
      }
    } else {
      if (allFacilities?.facilities) {
        return allFacilities?.facilities?.map((value) => ({
          value: value?.id,
          label: value?.name,
        }));
      } else {
        return [];
      }
    }
  };

  let obj = {
    facilities: returnFacilitiesArray(),
    clients: allPatients
      ? allPatients?.map((value) => ({
          value: value?.id,
          label: value?.name,
          disabled: !value?.active,
        }))
      : [],
    staff: staff?.staffs
      ? staff?.staffs?.map((value) => ({
          value: value?.id,
          label:
            value?.type === "staff" ? value?.name : `${value?.name} (admin)`,
        }))
      : [],
    "staff all": allStaff
      ? allStaff?.map((value) => ({
          value: value?.id,
          label:
            value?.type === "staff" ? value?.name : `${value?.name} (admin)`,
        }))
      : [],
    "facility types": allFacilityTypes?.ftypes
      ? allFacilityTypes?.ftypes?.map((value) => ({
          value: value?.id,
          label: value?.name,
        }))
      : [],

    other: othersArray
      ? othersArray?.map((value) => ({
          value: value,
          label: value,
        }))
      : [],
    "multiple choices":
      multipleChoice?.length > 0
        ? multipleChoice?.map((value) => ({
            value: value,
            label: value,
          }))
        : [],
    "single choice":
      singleChoice?.length > 0
        ? singleChoice?.map((value) => ({
            value: value,
            label: value,
          }))
        : [],
    dropdown:
      dropdownChoice?.length > 0
        ? dropdownChoice?.map((value) => ({
            value: value,
            label: value,
          }))
        : [],
    "level of need": [
      {
        value: "LON 1 - Intermittent",
        label: "LON 1 - Intermittent",
      },
      {
        value: "LON 5 - Limited",
        label: "LON 5 - Limited",
      },
      {
        value: "LON 8 - Extensive",
        label: "LON 8 - Extensive",
      },
      {
        value: "LON 6 - Pervasive",
        label: "LON 6 - Pervasive",
      },
      {
        value: "LON 9 - Pervasive+",
        label: "LON 9 - Pervasive+",
      },
    ],
  };

  return obj[optionType?.toLowerCase()];
};

let secretKey = "ogiso-life-secret";
export let noteType_Client = "Client Name";
export let noteType_Client_Options = "Clients";

/**
 * Safely decode a JWT token
 * @param {string} token
 * @returns {object|null}
 */
export const decodeJwt = (token) => {
  if (!token || typeof token !== "string") return null;

  try {
    return jwtDecode(token);
  } catch (error) {
    console.error("JWT decode failed:", error);
    return null;
  }
};

export const decrypt = (cipher, parse = true) => {
  try {
    var bytes = CryptoJS.AES.decrypt(cipher, secretKey);
    var originalText = bytes.toString(CryptoJS.enc.Utf8);
    // let secretKey = process.env.REACT_APP_ENCRYPT_SECRET;
    if (parse) return JSON.parse(originalText);
    else return originalText;
  } catch (e) {
    return originalText;
  }
};

export const encrypt = (data) => {
  // let secretKey = process.env.REACT_APP_ENCRYPT_SECRET;
  var ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretKey,
  ).toString();
  return ciphertext;
};

export const sortByDateAndTime = (arr) => {
  const newArr = arr?.length > 0 ? [...arr] : [];

  newArr?.sort((a, b) => {
    const dateA = moment(a?.date);
    const _slotA = getActiveSlotForDate(a?.timeSlot, a?.date);
    const timeA = moment(_slotA ? _slotA : a?.date, "hh:mm A");
    const combinedDateTimeA = moment({
      year: dateA.year(),
      month: dateA.month(),
      date: dateA.date(),
      hour: timeA.hours(),
      minute: timeA.minutes(),
    });

    const dateB = moment(b?.date);
    const _slotB = getActiveSlotForDate(b?.timeSlot, b?.date);
    const timeB = moment(_slotB ? _slotB : b?.date, "hh:mm A");
    const combinedDateTimeB = moment({
      year: dateB.year(),
      month: dateB.month(),
      date: dateB.date(),
      hour: timeB.hours(),
      minute: timeB.minutes(),
    });

    return combinedDateTimeB - combinedDateTimeA;
  });

  return newArr;
};

export const getPriorityColor = (date, data) => {
  // Missed #eb7a74
  // Unable to Take #feff80
  // Refused #c7daf5
  // PRN #a03399
  // Taken #4fa80d
  // Out of Medication #000
  // upcoming #979797
  const _dateFormat = "YYYY-MM-DD";
  const types = data
    ?.filter(
      (x) =>
        moment(date).format(_dateFormat) ===
        moment(x?.date).format(_dateFormat),
    )
    ?.map((v) => {
      if (Array.isArray(v?.medicationType)) {
        const targetDateStr = moment(date).format(_dateFormat);
        // Try slot-aware match first; fall back to date-only match so records
        // stored without a timeSlot field (virtual upcoming entries) still resolve.
        const entry =
          v.medicationType.find(
            (m) =>
              moment(m.date).format(_dateFormat) === targetDateStr &&
              (!m.timeSlot || m.timeSlot === v.timeSlot),
          ) ||
          v.medicationType.find(
            (m) => moment(m.date).format(_dateFormat) === targetDateStr,
          );
        return entry ? entry.status : "upcoming";
      }

      return v?.medicationType;
    });

  return checkType(types);
};

export const getDailyPriorityColor = (data) => {
  const types = data?.map((v) => {
    if (Array.isArray(v?.medicationType)) {
      const targetDateStr = moment(v.date).format("YYYY-MM-DD");
      // Try slot-aware match first; fall back to date-only for virtual entries.
      const entry =
        v.medicationType.find(
          (m) =>
            moment(m.date).format("YYYY-MM-DD") === targetDateStr &&
            (!m.timeSlot || m.timeSlot === v.timeSlot),
        ) ||
        v.medicationType.find(
          (m) => moment(m.date).format("YYYY-MM-DD") === targetDateStr,
        );
      return entry ? entry.status : "upcoming";
    }

    return v?.medicationType;
  });
  return checkType(types);
};

const checkType = (types) => {
  if (types?.includes("Missed")) {
    return "#eb7a74";
  } else if (types?.includes("Unable to Take")) {
    return "#feff80";
  } else if (types?.includes("Refused")) {
    return "#c7daf5";
  } else if (types?.includes("PRN")) {
    return "#a03399";
  } else if (types?.includes("Taken")) {
    return "#4fa80d";
  } else if (types?.includes("Out of Medication")) {
    return "#000";
  } else if (types?.includes("upcoming")) {
    return "#979797";
  } else {
    return "#fff";
  }
};

// Returns all time strings from a MAR timeSlot array that are active on the given date.
// Filters by effectiveFrom / effectiveTo so removed/added slots respect their edit date.
export const getActiveSlotsForDate = (timeSlotArr, date) => {
  if (!Array.isArray(timeSlotArr)) return [];
  const dateObj = moment(date).startOf("day");
  return timeSlotArr
    .filter((slot) => {
      if (!slot?.time) return false;
      const from = slot.effectiveFrom ? moment(slot.effectiveFrom).startOf("day") : null;
      const to = slot.effectiveTo ? moment(slot.effectiveTo).startOf("day") : null;
      if (from && from.isAfter(dateObj, "day")) return false;
      if (to && to.isBefore(dateObj, "day")) return false;
      return true;
    })
    .map((slot) => slot.time);
};

// Convenience: returns the first active slot string for a date, or null.
export const getActiveSlotForDate = (timeSlot, date) => {
  if (Array.isArray(timeSlot)) return getActiveSlotsForDate(timeSlot, date)[0] ?? null;
  if (typeof timeSlot === "string") return timeSlot;
  // timeSlot may be a single slot object {time, effectiveFrom, effectiveTo, _id}
  if (timeSlot && typeof timeSlot === "object" && typeof timeSlot.time === "string") return timeSlot.time;
  return null;
};

export const getSpecificMedicationStatus = (medicationTypeArray, targetDate, targetTimeSlot) => {
  const isPastDay = moment(targetDate).isBefore(moment().startOf("day"));

  // For today's date, also check if the specific time slot has already passed.
  // A slot at 2:00 PM that was never administered should be "Missed" once 2pm passes.
  const isTodaySlotPast = !isPastDay && (() => {
    const tSlot = Array.isArray(targetTimeSlot) ? targetTimeSlot[0]?.time : targetTimeSlot;
    if (!tSlot) return false;
    const slotMoment = moment(tSlot, "hh:mm A");
    if (!slotMoment.isValid()) return false;
    const slotDateTime = moment(targetDate).startOf("day").set({
      hour: slotMoment.hours(),
      minute: slotMoment.minutes(),
      second: 0,
    });
    return slotDateTime.isBefore(moment());
  })();

  const isPast = isPastDay || isTodaySlotPast;

  if (typeof medicationTypeArray === "string") {
    if (medicationTypeArray.toLowerCase() === "upcoming" && isPast) return "Missed";
    return medicationTypeArray;
  }

  if (!Array.isArray(medicationTypeArray) || medicationTypeArray.length === 0) {
    return isPast ? "Missed" : "upcoming";
  }

  const _dateFormat = "YYYY-MM-DD";
  // Use UTC for all date comparisons — dates are stored as UTC midnight so local
  // timezone conversion would shift them by a day for UTC+ users.
  const targetDateStr = moment.utc(targetDate).format(_dateFormat);
  const tSlot = Array.isArray(targetTimeSlot) ? targetTimeSlot[0]?.time : targetTimeSlot;

  const matches = medicationTypeArray.filter((m) => {
    const isSameDate = moment.utc(m.date).format(_dateFormat) === targetDateStr;
    const mSlot = Array.isArray(m.timeSlot) ? m.timeSlot[0] : m.timeSlot;
    const isSameSlot = (!mSlot || mSlot === tSlot);
    return isSameDate && isSameSlot;
  });

  if (matches.length > 0) {
    const status = matches[matches.length - 1].status;
    if (typeof status === "string" && status.toLowerCase() === "upcoming" && isPast) return "Missed";
    return status;
  }

  const dateOnlyMatches = medicationTypeArray.filter(
    (m) => moment.utc(m.date).format(_dateFormat) === targetDateStr,
  );
  if (dateOnlyMatches.length > 0) {
    const status = dateOnlyMatches[dateOnlyMatches.length - 1].status;
    if (typeof status === "string" && status.toLowerCase() === "upcoming" && isPast) return "Missed";
    return status;
  }

  return isPast ? "Missed" : "upcoming";
};

export const firstLetterCap = (str) => {
  return str ? str?.[0].toUpperCase() + str?.slice(1) : str;
};

export function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
}

export function getAllTimezonesWithAbbr() {
  const timezones = moment.tz.names();

  return timezones.map((tz) => {
    const now = moment.tz(tz);
    const offset = now.utcOffset();
    const offsetHours = Math.floor(offset / 60);
    const offsetMinutes = offset % 60;
    const sign = offset >= 0 ? "+" : "-";
    const paddedHours = String(Math.abs(offsetHours)).padStart(2, "0");
    const paddedMinutes = String(Math.abs(offsetMinutes)).padStart(2, "0");
    const gmtOffset = `(GMT${sign}${paddedHours}:${paddedMinutes})`;
    const abbr = now.zoneAbbr(); // returns PST, MST, etc.

    return {
      label: `${gmtOffset} ${tz} (${abbr})`,
      value: tz,
    };
  });
}

export const getAbbreviationFromName = (stateName) => {
  const state = usStates?.find((s) => s?.name === stateName);
  return state ? state?.abbreviation : "";
};

export const getNameFromAbbreviation = (stateAbbrev) => {
  const state = usStates?.find((s) => s?.abbreviation === stateAbbrev);
  return state ? state?.name : "";
};

export const obfuscateEmail = (email) => {
  if (!email) return "No email found";

  const [name, domain] = email.split("@");

  // Keep first 2 and last 2 characters, mask the middle
  let maskedName;
  if (name.length <= 4) {
    // For very short names, mask everything except first letter
    maskedName = name[0] + "***";
  } else {
    const firstTwo = name.slice(0, 2);
    const lastTwo = name.slice(-2);
    const maskedCount = name.length - 4;
    maskedName = `${firstTwo}${"*".repeat(maskedCount)}${lastTwo}`;
  }

  return `${maskedName}@${domain}`;
};

export const obfuscatePhone = (phone) => {
  if (!phone) return "No phone found";

  // Extract digits only
  const digits = phone.replace(/\D/g, "");

  if (digits.length <= 4) return digits; // too short to mask

  // Detect country code (1–3 digits)
  // If original phone starts with "+", assume the first 1–3 digits are country code
  let countryCode = "";
  let mainNumber = digits;

  if (phone.trim().startsWith("+")) {
    // Country code is typically 1-3 digits
    countryCode = digits.slice(0, digits.length - 10); // Assume last 10 digits are national number
    if (countryCode.length === 0) {
      countryCode = digits.slice(0, 1); // fallback minimal CC
    }
    mainNumber = digits.slice(countryCode.length);
  }

  // Now mask mainNumber
  if (mainNumber.length <= 5) {
    // Not enough digits to format normally
    return `+${countryCode}${mainNumber}`;
  }

  const firstThree = mainNumber.slice(0, 3);
  const lastTwo = mainNumber.slice(-2);
  const masked = `${firstThree}${"*".repeat(mainNumber.length - 5)}${lastTwo}`;

  return countryCode ? `+${countryCode}${masked}` : masked;
};

export const usStates = [
  { abbreviation: "AL", name: "Alabama" },
  { abbreviation: "AK", name: "Alaska" },
  { abbreviation: "AZ", name: "Arizona" },
  { abbreviation: "AR", name: "Arkansas" },
  { abbreviation: "CA", name: "California" },
  { abbreviation: "CO", name: "Colorado" },
  { abbreviation: "CT", name: "Connecticut" },
  { abbreviation: "DE", name: "Delaware" },
  { abbreviation: "FL", name: "Florida" },
  { abbreviation: "GA", name: "Georgia" },
  { abbreviation: "HI", name: "Hawaii" },
  { abbreviation: "ID", name: "Idaho" },
  { abbreviation: "IL", name: "Illinois" },
  { abbreviation: "IN", name: "Indiana" },
  { abbreviation: "IA", name: "Iowa" },
  { abbreviation: "KS", name: "Kansas" },
  { abbreviation: "KY", name: "Kentucky" },
  { abbreviation: "LA", name: "Louisiana" },
  { abbreviation: "ME", name: "Maine" },
  { abbreviation: "MD", name: "Maryland" },
  { abbreviation: "MA", name: "Massachusetts" },
  { abbreviation: "MI", name: "Michigan" },
  { abbreviation: "MN", name: "Minnesota" },
  { abbreviation: "MS", name: "Mississippi" },
  { abbreviation: "MO", name: "Missouri" },
  { abbreviation: "MT", name: "Montana" },
  { abbreviation: "NE", name: "Nebraska" },
  { abbreviation: "NV", name: "Nevada" },
  { abbreviation: "NH", name: "New Hampshire" },
  { abbreviation: "NJ", name: "New Jersey" },
  { abbreviation: "NM", name: "New Mexico" },
  { abbreviation: "NY", name: "New York" },
  { abbreviation: "NC", name: "North Carolina" },
  { abbreviation: "ND", name: "North Dakota" },
  { abbreviation: "OH", name: "Ohio" },
  { abbreviation: "OK", name: "Oklahoma" },
  { abbreviation: "OR", name: "Oregon" },
  { abbreviation: "PA", name: "Pennsylvania" },
  { abbreviation: "RI", name: "Rhode Island" },
  { abbreviation: "SC", name: "South Carolina" },
  { abbreviation: "SD", name: "South Dakota" },
  { abbreviation: "TN", name: "Tennessee" },
  { abbreviation: "TX", name: "Texas" },
  { abbreviation: "UT", name: "Utah" },
  { abbreviation: "VT", name: "Vermont" },
  { abbreviation: "VA", name: "Virginia" },
  { abbreviation: "WA", name: "Washington" },
  { abbreviation: "WV", name: "West Virginia" },
  { abbreviation: "WI", name: "Wisconsin" },
  { abbreviation: "WY", name: "Wyoming" },
];

export const getInitialAdminPermissions = (staff) => {
  const permissions = staff?.permissions;
  return {
    aiAccess: true,
    staff: true,
    task: true,
    note: true,
    medication: true,
    // report: true,
    facility: true,
    invoice: true,
    billing: permissions?.billing === true,
  };
};

export const initialManagerPermissions = {
  aiAccess: true,
  staff: true,
  task: true,
  note: true,
  medication: true,
  // report: true,
  facility: true,
  invoice: true,
  billing: false,
};

export const initialStaffPermissions = {
  aiAccess: true,
  staff: false,
  task: true,
  note: true,
  medication: true,
  // report: true,
  facility: false,
  invoice: false,
  billing: false,
};

export const initialContractorPermissions = {
  aiAccess: true,
  staff: true,
  task: true,
  note: true,
  medication: true,
  // report: true,
  facility: true,
  invoice: true,
  billing: true,
};

export const PERMISSION_LABELS = {
  aiAccess: "AI Access",
  staff: "Staff",
  task: "Task",
  note: "Notes",
  medication: "Medication",
  // report: "Report",
  facility: "Facility",
  invoice: "Invoice",
  billing: "Billing",
};

export const isIncompleteAddressDetails = (profile) => {
  if (!profile?.user?.role && !profile?.user?.type && profile?.business) {
    const requiredFields = ["line1", "country", "state", "city", "postal_code"];
    const hasMissingField = requiredFields.some(
      (field) => !profile?.business[field],
    );
    return hasMissingField;
  } else if (
    !profile?.user?.role &&
    !profile?.user?.type &&
    !profile?.business
  ) {
    return true;
  } else {
    return false;
  }
};

export const extractAddressFieldsFromGoogleRes = (res) => {
  if (!res || !res.result) return {};

  const components = res.result.address_components || [];
  const formattedAddress = res.result.formatted_address || "";

  const get = (type, short = false) =>
    components.find((c) => c.types.includes(type))?.[
      short ? "short_name" : "long_name"
    ] || "";

  const city = get("locality") || get("administrative_area_level_2") || "";
  const state = get("administrative_area_level_1", true) || "";
  const postal_code = get("postal_code") || "";
  const countryShort = get("country", true) || "";
  const countryFull = get("country", false) || "";

  // Remove postal_code, state, city, countryFull from formattedAddress to get line1
  let line1 = formattedAddress;

  [postal_code, state, city, countryFull].forEach((val) => {
    if (val) {
      line1 = line1.replace(new RegExp(`\\s*,?\\s*${val}\\s*,?\\s*`, "g"), " ");
    }
  });

  // Remove multiple commas/spaces
  line1 = line1
    .replace(/\s*,\s*/g, ", ")
    .replace(/,+/g, ",")
    .replace(/^,|,$/g, "")
    .trim();

  // Replace multiple spaces with single space
  line1 = line1.replace(/\s+/g, " ");

  return {
    line1: res?.result?.name || line1,
    city,
    state,
    postal_code,
    country: countryShort, // short country code
  };
};

export const countries = [
  { name: "Afghanistan", code: "AF" },
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "Andorra", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Antigua and Barbuda", code: "AG" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Brazil", code: "BR" },
  { name: "Brunei", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cabo Verde", code: "CV" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Central African Republic", code: "CF" },
  { name: "Chad", code: "TD" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Colombia", code: "CO" },
  { name: "Comoros", code: "KM" },
  { name: "Congo (Congo-Brazzaville)", code: "CG" },
  { name: "Costa Rica", code: "CR" },
  { name: "Croatia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Cyprus", code: "CY" },
  { name: "Czechia", code: "CZ" },
  { name: "Democratic Republic of the Congo", code: "CD" },
  { name: "Denmark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominica", code: "DM" },
  { name: "Dominican Republic", code: "DO" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "El Salvador", code: "SV" },
  { name: "Equatorial Guinea", code: "GQ" },
  { name: "Eritrea", code: "ER" },
  { name: "Estonia", code: "EE" },
  { name: "Eswatini", code: "SZ" },
  { name: "Ethiopia", code: "ET" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "Gabon", code: "GA" },
  { name: "Gambia", code: "GM" },
  { name: "Georgia", code: "GE" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Greece", code: "GR" },
  { name: "Grenada", code: "GD" },
  { name: "Guatemala", code: "GT" },
  { name: "Guinea", code: "GN" },
  { name: "Guinea-Bissau", code: "GW" },
  { name: "Guyana", code: "GY" },
  { name: "Haiti", code: "HT" },
  { name: "Holy See", code: "VA" },
  { name: "Honduras", code: "HN" },
  { name: "Hungary", code: "HU" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Iran", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Ireland", code: "IE" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Jordan", code: "JO" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kiribati", code: "KI" },
  { name: "Kuwait", code: "KW" },
  { name: "Kyrgyzstan", code: "KG" },
  { name: "Laos", code: "LA" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lesotho", code: "LS" },
  { name: "Liberia", code: "LR" },
  { name: "Libya", code: "LY" },
  { name: "Liechtenstein", code: "LI" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Madagascar", code: "MG" },
  { name: "Malawi", code: "MW" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Mali", code: "ML" },
  { name: "Malta", code: "MT" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Mauritania", code: "MR" },
  { name: "Mauritius", code: "MU" },
  { name: "Mexico", code: "MX" },
  { name: "Micronesia", code: "FM" },
  { name: "Moldova", code: "MD" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolia", code: "MN" },
  { name: "Montenegro", code: "ME" },
  { name: "Morocco", code: "MA" },
  { name: "Mozambique", code: "MZ" },
  { name: "Myanmar", code: "MM" },
  { name: "Namibia", code: "NA" },
  { name: "Nauru", code: "NR" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands", code: "NL" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nicaragua", code: "NI" },
  { name: "Niger", code: "NE" },
  { name: "Nigeria", code: "NG" },
  { name: "North Korea", code: "KP" },
  { name: "North Macedonia", code: "MK" },
  { name: "Norway", code: "NO" },
  { name: "Oman", code: "OM" },
  { name: "Pakistan", code: "PK" },
  { name: "Palau", code: "PW" },
  { name: "Palestine State", code: "PS" },
  { name: "Panama", code: "PA" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Paraguay", code: "PY" },
  { name: "Peru", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Qatar", code: "QA" },
  { name: "Romania", code: "RO" },
  { name: "Russia", code: "RU" },
  { name: "Rwanda", code: "RW" },
  { name: "Saint Kitts and Nevis", code: "KN" },
  { name: "Saint Lucia", code: "LC" },
  { name: "Saint Vincent and the Grenadines", code: "VC" },
  { name: "Samoa", code: "WS" },
  { name: "San Marino", code: "SM" },
  { name: "Sao Tome and Principe", code: "ST" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Senegal", code: "SN" },
  { name: "Serbia", code: "RS" },
  { name: "Seychelles", code: "SC" },
  { name: "Sierra Leone", code: "SL" },
  { name: "Singapore", code: "SG" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Solomon Islands", code: "SB" },
  { name: "Somalia", code: "SO" },
  { name: "South Africa", code: "ZA" },
  { name: "South Korea", code: "KR" },
  { name: "South Sudan", code: "SS" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sudan", code: "SD" },
  { name: "Suriname", code: "SR" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Syria", code: "SY" },
  { name: "Tajikistan", code: "TJ" },
  { name: "Tanzania", code: "TZ" },
  { name: "Thailand", code: "TH" },
  { name: "Timor-Leste", code: "TL" },
  { name: "Togo", code: "TG" },
  { name: "Tonga", code: "TO" },
  { name: "Trinidad and Tobago", code: "TT" },
  { name: "Tunisia", code: "TN" },
  { name: "Turkey", code: "TR" },
  { name: "Turkmenistan", code: "TM" },
  { name: "Tuvalu", code: "TV" },
  { name: "Uganda", code: "UG" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "United Kingdom", code: "GB" },
  { name: "United States of America", code: "US" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Vanuatu", code: "VU" },
  { name: "Venezuela", code: "VE" },
  { name: "Vietnam", code: "VN" },
  { name: "Yemen", code: "YE" },
  { name: "Zambia", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" },
];
